import { useTranslation } from "@opendash/i18n";
import { Dropdown, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTicketData } from "../..";
import { useDropdownItems } from "../hooks/useDropdownItems";
import { useSaveTicketProject } from "../hooks/useSaveTicketProject";
import { ProjectTag } from "./ticket/ProjectTag";

type Props = {
  onSave?: (projectId: string) => void;
};

export const ProjectDropdown = observer((props: Props) => {
  const t = useTranslation();
  const items = useDropdownItems();
  const ticketData = useTicketData();
  const saveProject = useSaveTicketProject();

  async function handleChangeProject(projectId: string) {
    await saveProject(projectId, ticketData.ticket.id);
    props.onSave?.(projectId);
  }

  const tooltip = ticketData.project
    ? t("maintenance:ticket.data.project", {
        project: ticketData.project.get("name"),
      })
    : t("maintenance:ticket.data.noProject");

  return (
    <Dropdown
      trigger={["click"]}
      menu={{ items, onClick: (info) => handleChangeProject(info.key) }}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
    >
      <Tooltip title={tooltip}>
        <div>
          <ProjectTag clickable={items?.length > 0} />
        </div>
      </Tooltip>
    </Dropdown>
  );
});
